export const APP_NAME = 'Cadrial';
export const APP_URL = process.env.NEXT_PUBLIC_APP_URL ?? 'http://localhost:3000';

export const PUBLIC_ROUTES = ['/login', '/invite', '/api/public/'];
export const AUTH_ROUTES = ['/login'];

// Httponly cookie carrying the read-only impersonation target uid. Defined
// here (not in the server-only super-admin module) so the middleware/proxy —
// which cannot import `server-only` code — and the server auth code share one
// source of truth for the name.
export const IMPERSONATION_COOKIE = 'cadrial_impersonate_uid';

export const RECORD_TYPES = ['company', 'contact', 'manufacturer'] as const;
export const NOTE_TYPES = ['Activities', 'Opportunities'] as const;

export const RECORD_TYPE_LABELS: Record<string, string> = {
  company: 'Companies',
  contact: 'Contacts',
  manufacturer: 'Manufacturers',
};

export const NOTE_TYPE_LABELS: Record<string, string> = {
  Activities: 'Activities',
  Opportunities: 'Opportunities',
};

export const ROUTES = {
  login: '/login',
  // Canonical page the app lands on when opened (root URL, post-auth, the
  // "Sales" header tab, logo/home). Activities is the day-to-day starting
  // point for reps, so it's the default rather than the Companies list.
  landing: '/sales/notes/activities',
  dashboard: '/sales/records/companies',
  records: (type: string) => `/sales/records/${type}`,
  recordManage: (type: string) => `/sales/records/${type}/manage`,
  notes: (type: string) => `/sales/notes/${type}`,
  reports: '/reports',
  reportDetail: (id: string) => `/reports/${id}`,
  import: '/reports/data/import',
  workspace: {
    members: '/workspace/members',
    memberPermissions: (uid: string) => `/workspace/members/${uid}/permissions`,
    teams: '/workspace/teams',
    territories: '/workspace/territories',
    customization: '/workspace/customization',
    billing: '/workspace/billing',
    integrations: '/workspace/integrations',
  },
  account: {
    profile: '/account/profile',
  },
} as const;
